module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia6-d5b5370434ec1c721a6b67845a9eb0da.jpg";